'use client';
import { formatDate } from '@/lib/dateTime';

import { TEvaluationModel } from '@/lib/evaluationModelsApi';
import { Stack } from '@/ui/primatives';
import { Row } from '@/ui/primatives';

import LogoIcon from '../LogoIcon';
import ModalityTags from '../ModalityTags';
import ModelPricing from '../ModelPricing';

import * as Styled from './styled';
import React from 'react';
import MarkdownViewer from '@/components/MarkdownViewer';

const ModelInfo: React.FC<{ model: TEvaluationModel; style?: React.CSSProperties }> = ({ model, style }) => {
  const developer = model.developer;
  return (
    <>
      <Styled.ModelInfo style={style} stretch>
        <Stack gap={20}>
          <Row gap={10} alignItems="center" justifyContent="space-between">
            <h6>
              <Row gap={5} alignItems="center">
                <LogoIcon
                  logoUrl={developer?.logo}
                  name={developer?.display_name || developer?.name || '?'}
                  height={18}
                />
                <span>
                  {developer && `${developer.display_name || developer.name} / `}
                  {model.display_name || model.name}
                </span>
              </Row>
            </h6>
            {model.released_at && (
              <span>
                Released: <b>{formatDate(model.released_at)}</b>
              </span>
            )}
          </Row>

          <Row gap={10} alignItems="center" justifyContent="space-between">
            <ModalityTags model={model} />
            <ModelPricing model={model} />
          </Row>
          <hr />
          <MarkdownViewer>{model.description!}</MarkdownViewer>
        </Stack>
      </Styled.ModelInfo>
    </>
  );
};

export default ModelInfo;
